import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import {LoginComponent, RegisterComponent, VerficationComponent, ForgetPasswordComponent,
ResetPasswordComponent, NotFoundComponent} from './authentication/index';
import {DashboardComponent} from './shared/index';
import { AuthGuardService, RoleGuardService } from './authentication/service/auth-guard.service';
import { MobileRedirectionComponent } from './mobile-redirection/mobile-redirection.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'registration',
    component: RegisterComponent,
  },
  {
    path: 'confirmverificationcode',
    component: VerficationComponent,
  }, {
    path: 'login/forgetpassword',
    component: ForgetPasswordComponent,
  }, {
    path: 'login/resetpassword',
    component: ResetPasswordComponent,
  },
  {
    path: 'mobileview',
    component: MobileRedirectionComponent,
  },
  {
    path: '', pathMatch: 'full',
    redirectTo: 'index',
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  // {
  //   path: '**',
  //   redirectTo: '404',
  // },
  {
    path: 'index', component: DashboardComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRole: ['WorkerSeller']
    }
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.errorHandler = (error: any) => {
        this.router.navigate(['404']); // or redirect to default route
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts